import request from '../utils/request';

// 参展商证列表
export function getLists() {
  return request({
    url: '/frontExhibitor/ZsCertificatesApply/list',
    method: 'get',
  });
}
// 新增参展人员
export function addExhibitors(data) {
  return request({
    url: '/frontExhibitor/ZsCertificatesApply/save',
    method: 'post',
    data: data,
  });
}

// 获取单个参展人员信息
export function getItem(data) {
  return request({
    url: '/frontExhibitor/ZsCertificatesApply/view',
    method: 'post',
    params: data,
  });
}

// 修改参展人员信息
export function editItem(data) {
  return request({
    url: '/frontExhibitor/ZsCertificatesApply/edit',
    method: 'post',
    data: data,
  });
}

// 删除参战人员
export function delItem(data) {
  return request({
    url: '/frontExhibitor/ZsCertificatesApply/delete',
    method: 'get',
    params: data,
  });
}

// 提交参展商证
export function submitList(data) {
  return request({
    url: '/frontExhibitor/ZsCertificatesApply/submit',
    method: 'post',
    data: data,
  });
}